import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import PlacePicker from '../picker/PlacePicker'

const PlacesFilter = ({ field, ...props }) => {
  field = field || 'placeIds'
  const label = 'Locais'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <PlacePicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default PlacesFilter
